export var MuiButtonBase = {
// disableRipple: true,
// disableTouchRipple: true,
};
//# sourceMappingURL=MuiButtonBase.js.map